<template>
  <v-card class="pa-8 dashboard_cards">
    <div class="d-flex align-center">
      <img
        src="../../../assets/icons/appusericon.png"
        alt=""
        width="30px"
        class="mr-2"
      >
      <h4>App Users</h4>
    </div>
    <div class="dashboard_card_count">
      <h1>{{ dashboardCounts.app_users || 0 }}</h1>
      <p>{{ lastUpdatedAt | diffHumans }}</p>
    </div>
  </v-card>
</template>
<script>
import moment from 'moment';
export default {
  name: 'DashboardAppuserCount',
  filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
    },
  computed: {
    dashboardCounts () {
        return this.$store.getters['dashboard/getDashboardCounts'];
      },
      lastUpdatedAt () {
        return this.$store.getters['dashboard/getLastUpdatedAt'];
      },
  },
  mounted () {
    this.lastUpdated();
  },
  methods: {
    lastUpdated () {
        this.$store.dispatch('dashboard/lastUpdatedAt', {
          updatedAt: moment().toISOString(),
        });
      },
  },
};
</script>
<style lang="scss" scoped>
    .dashboard_card_count{
    position: absolute;
    bottom: 10px;
}
.dashboard_cards{
    min-height: 200px;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    box-shadow: none !important;
    border: 1px solid #ccc;
    border-radius: 10px;
}
.dashboard_cards h4 {
    font-size: 22px;
    font-weight: 400;
    position: relative;
}
</style>
